import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import {RemoveRedEye as RemoveRedEyeIcon} from '@material-ui/icons';
import {GreatTable} from 'components/common';
import {levelMap} from 'utils/common';

const useTableStyles = withStyles({
  tableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
});

const QuizTable = useTableStyles(({classes, ...restProps}) => {
  return (
    <GreatTable
      {...restProps}
      itemName="quiz"
      getFieldsMapping={(quiz) => ({
        title: quiz.title,
        level: levelMap[quiz.level],
        readingNights: quiz.readingNights,
      })}
      getFieldsSettings={() => ({
        title: {
          fieldText: 'Title',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        level: {
          fieldText: 'Level',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        readingNights: {
          fieldText: 'Reading Nights',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
        },
        actions: {
          fieldText: 'Actions',
          headerCellClassName: classes.tableCell,
          bodyCellClassName: classes.tableCell,
          formatData: (cell, row) => (
            <Link to={`/quiz/${row.id}`} title="view">
              <RemoveRedEyeIcon />
            </Link>
          ),
        },
      })}
    />
  );
});

export default QuizTable;
